import React from 'react';
import { useTranslation } from 'react-i18next';

interface SingleTerminalProps {
  terminal?: string;
  gate?: string;
}

interface DepartureArrivalProps {
  departure: {
    terminal?: string;
    gate?: string;
  };
  arrival: {
    terminal?: string;
    gate?: string;
  };
}

type FlightTerminalInfoProps = SingleTerminalProps | DepartureArrivalProps;

const FlightTerminalInfo: React.FC<FlightTerminalInfoProps> = (props) => {
  const { t } = useTranslation();

  // Check if we're rendering departure/arrival or single terminal
  if ('departure' in props && 'arrival' in props) {
    // Departure and arrival terminal display
    const { departure, arrival } = props;
    
    return (
      <div className="flex justify-between w-full text-xs text-travel-400">
        <div className="flex flex-col items-start gap-3">
          <span>{t("tripCard.terminal")}: {departure.terminal || '-'}</span>
          <span>{t("tripCard.gate")}: {departure.gate || '-'}</span>
        </div>
        <div className="flex flex-col items-end gap-3">
          <span>{t("tripCard.terminal")}: {arrival.terminal || '-'}</span>
          <span>{t("tripCard.gate")}: {arrival.gate || '-'}</span>
        </div>
      </div>
    );
  } else {
    // Single terminal display
    const { terminal, gate } = props;
    
    return (
      <span className="text-xs text-travel-400">
        {t("tripCard.terminal")}: {terminal || '-'}
        <span className="mx-2">•</span>
        {t("tripCard.gate")}: {gate || '-'}
      </span>
    );
  }
};

export default FlightTerminalInfo;
